import { render, staticRenderFns } from "./header-search.vue?vue&type=template&id=b9c33d98&scoped=true"
import script from "./header-search.vue?vue&type=script&lang=js"
export * from "./header-search.vue?vue&type=script&lang=js"
import style0 from "./header-search.vue?vue&type=style&index=0&id=b9c33d98&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c33d98",
  null
  
)

export default component.exports